export default class ArtistForm
{
    constructor(artist_info, art_work){
        this.artist_info    = artist_info
        this.art_work       = art_work
    }

    toFormData(){
        let fData = new FormData()
        fData.append('from_lang', 'ar');

        fData.append('name1', this.artist_info.name1);
        fData.append('name2', this.artist_info.name2);
        fData.append('name3', this.artist_info.name3);
        fData.append('artistic_name', this.artist_info.artistic_name);
        fData.append('birth_date', this.artist_info.birth_date);
        fData.append('gender_id', this.artist_info.gender_id);
        fData.append('phone1', this.artist_info.phone1);
        fData.append('phone2', this.artist_info.phone2);
        fData.append('education_level_id', this.artist_info.certificate_id);
        fData.append('study_specialization', this.artist_info.academic_specialization);
        fData.append('email', this.artist_info.email);
        fData.append('country_id', this.artist_info.country_id.id);
        fData.append('province', this.artist_info.country_id.id == 39 ? this.artist_info.city_id : this.artist_info.city_name);

        // معلومات العمل الفني 
        for (let i = 0; i < this.art_work.fields.length; i++) {
            const element = this.art_work.fields[i];
            
            fData.append('artists['+i+'][sub_id]', element.sub_section_id); 
            fData.append('artists['+i+'][artwork_name]', element.artwork_name); 
            fData.append('artists['+i+'][link]', element.additional_link); 
            fData.append('artists['+i+'][note]', element.notes); 

            if(typeof element.attachment_1 == 'object')
                fData.append('artists['+i+'][attachments][0]', element.attachment_1); 
        }

        return fData
    }
}

